import request from "@/utils/request";
export function fetchList(query) {
    return request({
        url: '/admin/app/getGjsCorporateCulturePage',
        method: 'get',
        params: query
    })
}
export function fetchSix(query) {
    return request({
        url: '/admin/app/getGjsCorporateCultureLast',
        method: 'get',
        params: query
    })
}
export function fetchDetail(query) {
    return request({
        url: '/admin/app/getGjsCorporateCultureDetail',
        method: 'get',
        params: query
    })
}
